import {
  SET_BODYPARTS,
  SET_BODYPARTS_QUERY_PARAMS,
  SET_BODYPARTS_SET_IS_FETCHING,
} from '../constants/bodyPartsActionsTypes';

const initialState = {
  list: [],
  params: {
    per_page: 10,
    page: 1,
    sort: 'created_at,desc',
    search: '',
  },
  isFetching: false,
  total: 0,
};

function bodyParts(state = initialState, action) {
  switch (action.type) {
    case SET_BODYPARTS:
      return {
        ...state,
        list: action.data.bodyParts,
        total: action.data.total,
      };
    case SET_BODYPARTS_QUERY_PARAMS:
      return {
        ...state,
        params: {
          ...state.params,
          ...action.params,
        },
      };
    case SET_BODYPARTS_SET_IS_FETCHING:
      return {
        ...state,
        isFetching: action.isFetching,
      };
    default:
      return state;
  }
}

export default bodyParts;
